import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { ICapacityLimit, ICapacityLimitsForm } from './types'

const messages = defineMessages({
  required: {
    id: 'settings.form.limit.required',
    defaultMessage: 'The limit is required'
  },
  min: {
    id: 'settings.form.limit.min',
    defaultMessage: 'The limit should be more than 0'
  }
})

const passengersSchema = (intl: IntlShape): yup.SchemaOf<ICapacityLimit> => {
  return yup.object().shape({
    key: yup.string().required(),
    value: yup.number().when('isVisible', {
      is: (isVisible: boolean): TSFixMe => isVisible,
      then: (schema): TSFixMe => schema.required(intl.formatMessage(messages.required)),
      otherwise: (schema): TSFixMe => schema.optional()
    }),
    isVisible: yup.boolean().optional()
  })
}

export const capacityLimitsSchema = (intl: IntlShape): yup.SchemaOf<ICapacityLimitsForm> => {
  return yup.object().shape({
    limits: yup.array(passengersSchema(intl)).required(),
    passengers: yup.array().of(passengersSchema(intl)).required(),
    properties: yup.array().of(passengersSchema(intl)).required()
  })
}
